define([
    "skylark-utils/noder"
], function(noder) {
    return noder;
});
